import './hero-activity.css';

export function HeroActivityLine({ current, next, connected, language }: { current: string; next: string; connected: boolean; language: 'ru' | 'en' }) {
  return <div className="hero-activity-line" aria-label={language === 'ru' ? 'Занятие героя' : 'Hero activity'}>
    {!connected && <span className="hero-activity-stale">{language === 'ru' ? 'Нет связи · последнее известное:' : 'Disconnected · last confirmed:'}</span>}
    <span>{current}</span>
    {next && <span className="hero-activity-next">{next}</span>}
  </div>;
}
